// extracted by mini-css-extract-plugin
export default {"main":"bce3b9fef2","tit":"_247f99acff","maintitle":"ccbb3693d8","ylw":"e56d36ed40","white":"b06fdb2257","mv_title":"_5704a1a2dc","mv_nc":"_01e1abaaa3","mv_in":"_4f9d078faa"};